var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('keep-alive',[_c('div',{staticClass:"main-container"},[_c('breadcrumb',{attrs:{"list":_vm.breadcrumbList}}),_c('tl-tabs',{staticClass:"margintop-20",attrs:{"tabs":_vm.tabs,"customclass":true},on:{"changeTab":function($event){return _vm.onTabChange()}}},[_c('tl-tab',[_c('fbpLock')],1),_c('tl-tab',[_c('fbpDeclaration')],1)],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }